export const STATS_FRESHNESS_MINUTES = 15;
export const STATS_POLL_INTERVAL_MS = 60_000;
